export default __webpack_public_path__ + "static/histogram-with-specified-bins-4b6d80327dfe028d52bb6eea86889107.png";